'use strict';

/**
 * @ngdoc function
 * @name myConsultApp.controller:mediaCtrl
 * @description
 * # mediaCtrl
 * Controller of the myConsultApp
 */
angular
  .module('myConsultApp')
  .controller(
    'mediaCtrl',
    function (
      $rootScope,
      $scope,
      $location,
      crumble,
      MediaService,
      InvitationService,
      blockUI,
    ) {
      if ($scope.isAdminUser || $scope.isSuperUser) {
        $location.path('/admin');
      }
      $scope.crumble = crumble;
      crumble.update();

      /*
       *   Scope Variables
       */

      $scope.currentOrg = null;
      $scope.showNorecord = false;
      $scope.petsresults = [];
      $scope.resMsgStatus = true;
      $scope.has_error = false;
      $scope.field_type = '';
      $scope.sortType = 'updated'; // set the default sort type
      $scope.currentSort = 'updated';
      $scope.filterSort = '-updated';
      $scope.findmediaForm = { search: '' };
      $scope.findmediaForm.types = {};
      $scope.types = [];
      $scope.findmediaForm.categories = {};
      $scope.categories = [];
      $scope.findmediaForm.categories.appTigger = true;
      $scope.categories.push(parseInt(1));
      $scope.findmediaForm.categories.appHoneyPot = false;
      $scope.paginationData = [];
      $scope.sortReverse = true;
      $scope.searchParam = null;
      $scope.noSearchYet = true;
      $scope.mediaTypes = [];
      $scope.pageSize = 20;

      /*
       *   Scope Methods
       */

      //-- Function created for resuse in filter also
      $scope.loadMediaInfo = function (search) {
        var searchOrg = '';
        $scope.noSearchYet = false;

        if ($scope.organizationFilter === 'all') {
          $rootScope.adminPage = true;
        } else {
          searchOrg = $scope.organizationFilter;
          if ($location.$$url.indexOf('/admin') > -1) {
            $rootScope.adminPage = true;
          } else {
            $rootScope.adminPage = false;
          }
          if ($scope.isAdminUser && $scope.currentOrganization.id !== $scope.organizationFilter) {
            $rootScope.adminPage = true;
          }
        }
        MediaService.getMedia(
          search,
          '',
          null,
          $scope.types.toString(),
          $scope.categories.toString(),
          searchOrg,
          $scope.filterSort,
          $scope.pageSize,
        ).then(function (response) {
          $scope.mediaResults = response.files;
          $scope.paginationData = response;
          $scope.showNorecord = true;
          blockUI.stop();
        });
      };

      $scope.loadMediaTypes = function () {
        MediaService.getMediaTypes().then(function (response) {
          $scope.mediaTypes = response.types;
          if (Array.isArray(response.types) && response.types.length > 0) {
            angular.forEach(response.types, function (value, key) {
              $scope.findmediaForm.types[value.slug] = true;
              $scope.types.push(value.id);
            });
          }
          $scope.loadMediaInfo(null);
        });
      };

      $scope.filterOrganization = function (organizationFilter) {
        $('.search-section').removeClass('has-error').find('.help-block').hide();
        $scope.noSearchYet = false;
        $scope.organizationFilter = organizationFilter;

        if (organizationFilter === 'all') {
          $scope.validateSearch();
        } else {
          $scope.findmediaForm.search = '';
          $scope.searchParam = $scope.findmediaForm.search;
          $scope.loadMediaInfo($scope.searchParam);
        }
      };

      $scope.submitFindAMedia = function (findmediaForm) {
        var order = $scope.filterSort;
        $scope.noSearchYet = false;

        if ($scope.isAdminUser) {
          angular.forEach(findmediaForm.isActive, function (value, key) {
            var id = '#' + key;
            if (document.getElementById(key).checked) {
              var index = $scope.isActive.indexOf(parseInt($(id).val()));
              if (index <= -1) {
                $scope.isActive.push(parseInt($(id).val()));
              }
            } else {
              var index = $scope.isActive.indexOf(parseInt($(id).val()));
              if (index > -1) {
                $scope.isActive.splice(index, 1);
              }
            }
          });
        }
        angular.forEach(findmediaForm.categories, function (value, key) {
          var id = '#' + key;
          if (document.getElementById(key) && document.getElementById(key).checked) {
            var index = $scope.categories.indexOf(parseInt($(id).val()));
            if (index <= -1) {
              $scope.categories.push(parseInt($(id).val()));
            }
          } else {
            var index = $scope.categories.indexOf(parseInt($(id).val()));
            if (index > -1) {
              $scope.categories.splice(index, 1);
            }
          }
        });
        $scope.types = [];
        angular.forEach(findmediaForm.types, function (value, key) {
          var id = '#' + key;
          if (document.getElementById(key) && document.getElementById(key).checked) {
            var index = $scope.types.indexOf($(id).val());
            if (index <= -1) {
              $scope.types.push($(id).val());
            }
          } else {
            var index = $scope.types.indexOf($(id).val());
            if (index > -1) {
              $scope.types.splice(index, 1);
            }
          }
        });
        blockUI.start('Loading...');
        $scope.searchParam = findmediaForm.search;
        $scope.loadMediaInfo($scope.searchParam);
      };

      $scope.validateSearch = function () {
        $('.search-section').removeClass('has-error').find('.help-block').hide();
        if ($scope.organizationFilter === 'all') {
          if ($scope.findmediaForm.search.trim().length >= 2) {
            $scope.submitFindAMedia($scope.findmediaForm);
          } else {
            $('.search-section').addClass('has-error').find('.help-block').show();
          }
        } else {
          $scope.submitFindAMedia($scope.findmediaForm);
        }
      };

      $scope.goToEdit = function (media) {
        // $scope.setCurrentMedia(meida);
        $location.path('/media/edit/' + media.id);
      };

      $scope.goToPage = function (pageURL) {
        MediaService.getMediaPage(pageURL).then(function (response) {
          $scope.mediaResults = response.files;
          $scope.paginationData = response;
        });
      };

      $scope.setSort = function (sort) {
        var findmediaForm = $scope.findmediaForm;
        if ($scope.sortType === sort) {
          $scope.reverseSort();
        } else {
          $scope.sortType = sort;
          $scope.currentSort = sort.replace('-', '');
        }
        if ($scope.sortReverse == true) {
          var order = '-' + sort;
        } else {
          var order = sort;
        }
        $scope.filterSort = order;
        angular.forEach(findmediaForm.categories, function (value, key) {
          var id = '#' + key;
          if (document.getElementById(key) && document.getElementById(key).checked) {
            var index = $scope.categories.indexOf(parseInt($(id).val()));
            if (index <= -1) {
              $scope.categories.push(parseInt($(id).val()));
            }
          } else {
            var index = $scope.categories.indexOf(parseInt($(id).val()));
            if (index > -1) {
              $scope.categories.splice(index, 1);
            }
          }
        });
        angular.forEach(findmediaForm.types, function (value, key) {
          var id = '#' + key;
          if (document.getElementById(key) && document.getElementById(key).checked) {
            var index = $scope.types.indexOf($(id).val());
            if (index <= -1) {
              $scope.types.push($(id).val());
            }
          } else {
            var index = $scope.types.indexOf($(id).val());
            if (index > -1) {
              $scope.types.splice(index, 1);
            }
          }
        });
        $scope.validateSearch();
      };

      $scope.reverseSort = function () {
        $scope.sortReverse = !$scope.sortReverse;
      };

      $scope.invite = function (email, platform) {
        InvitationService.storeEmail(email);
        if (platform == 'pwl') {
          $location.path('/rewards');
        }
      };

      $scope.getAge = function (date) {
        var today = new Date();
        var birthDate = new Date(date);
        var age = today.getFullYear() - birthDate.getFullYear();
        var flag = today.getMonth() - birthDate.getMonth();
        if (flag < 0 || (flag === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      };

      /*
       *   Main
       */

      if ($scope.isAdminUser && $location.$$url.indexOf('/admin') > -1) {
        $scope.organizationFilter = 'all';
      } else {
        blockUI.start('Loading...');
        $scope.organizationFilter = $scope.currentOrganization.id;
        $scope.loadMediaTypes();
      }

      angular.element('#refineBtn').click(function (e) {
        e.preventDefault();
        $(this).find('.icon i').toggleClass('fa-minus');
        $(this).parent().parent().find('.refineFilters').toggleClass('expanded');
      });

      angular.element('.refineFilters ul li a').click(function (e) {
        e.preventDefault();
        $(this).find('.icon i').toggleClass('fa-minus');
        $(this).parent().toggleClass('expanded');
      });

      angular.element('#closePopUp').click(function (e) {
        e.preventDefault();
        if ($.easybox.isOpen()) {
          $.easybox.close();
        }
      });

      angular.element('a.lightbox').easybox({});

      angular.element('.search-section .help-block').hide();
    },
  );
